export const Entity = {
  FAMILY: 'FAMILY',
  GROUP: 'GROUP',
  PERSON: 'PERSON',
};
